<template>
  <nav
    class="current-user-nav"
  >
    <ul>
      <li
        class="current-user"
      >
        <router-link
          :to="{
            name: 'user',
            params: {
              userId: currentUser.id
            }
          }"
        >
          {{ displayName }}
        </router-link>
      </li>
      <li
        class="logout"
      >
        <router-link
          :to="{ name: 'sign_out' }"
        >
          Logout
        </router-link>
      </li>
    </ul>
  </nav>
</template>
<script>
import AuthStore from '@/stores/AuthStore'

export default {
  data () {
    return {
      currentUser: {}
    }
  },

  computed: {
    displayName () {
      return this.currentUser.name || this.currentUser.username
    }
  },

  created () {
    AuthStore.dispatch('getRecord').then((record) => {
      this.currentUser = record
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CurrentUserNav.vue